var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:[ _vm.buttonType, _vm.buttonSize, _vm.customClass, _vm.buttonDisabled ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_vm._t("default",function(){return [_vm._v("Button")]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }